import { Questionnaires } from "@/fhir/enums/questionnaires";

export const LAB_TEST_QUESTIONNAIRE_URLS: Record<string, string> = {
  blood: Questionnaires.LabBlood,
  "antibody-screen": Questionnaires.LabAntibodyScreen,
  cbc: Questionnaires.LabCbc,
  "diabetes-screen": Questionnaires.LabDiabetesScreen,
  gtt: Questionnaires.LabGtt,
  pap: Questionnaires.LabPap,
  hpv: Questionnaires.LabHpv,
  rubella: Questionnaires.LabRubella,
  gonorrhea: Questionnaires.LabGonorrhea,
  hbsag: Questionnaires.LabHbsag,
  chlamydia: Questionnaires.LabChlamydia,
  "tpa-rpr-vdrl": Questionnaires.LabTpaRprVdrl,
  gbs: Questionnaires.LabGbs,
  hiv: Questionnaires.LabHiv,
  tsh: Questionnaires.LabTsh,
  "tsh-reflex-t4f": Questionnaires.LabTshReflexT4f,
  "tsh-plus-free-t4": Questionnaires.LabTshPlusFreeT4,
  "hemoglobin-a1c": Questionnaires.LabHemoglobinA1c,
  "vitamin-d": Questionnaires.LabVitaminD,
  nipt: Questionnaires.LabNipt,
  "first-trimester-screen": Questionnaires.LabFirstTrimesterScreen,
  "carrier-screen": Questionnaires.LabCarrierScreen,
  "1-hour-gct": Questionnaires.Lab1HourGct,
  "fasting-glucose": Questionnaires.LabFastingGlucose,
  afp: Questionnaires.LabAfp,
  sma: Questionnaires.LabSma,
  "quad-screen": Questionnaires.LabQuadScreen,
  "cystic-fibrosis": Questionnaires.LabCysticFibrosis,
  hcg: Questionnaires.LabHcg,
  insulin: Questionnaires.LabInsulin,
  progesterone: Questionnaires.LabProgesterone,
  "total-testosterone": Questionnaires.LabTotalTestosterone,
  estradiol: Questionnaires.LabEstradiol,
  fsh: Questionnaires.LabFsh,
  lh: Questionnaires.LabLh,
  thyroid: Questionnaires.LabThyroid,
  "urine-culture-sensitivity": Questionnaires.LabUrineCultureSensitivity,
  "bacterial-vaginosis-swab": Questionnaires.LabBacterialVaginosisSwab,
  "vaginitis-swab": Questionnaires.LabVaginitisSwab,
  "trichomonas-swab-or-urine": Questionnaires.LabTrichomonasSwabOrUrine,
  "candida-swab": Questionnaires.LabCandidaSwab,
  "hepatitis-c": Questionnaires.LabHepatitisC,
  "varicella-igg": Questionnaires.LabVaricellaIgg,
  "3-hour-gtt": Questionnaires.Lab3HourGtt,
  "2-hour-gtt": Questionnaires.Lab2HourGtt,
  amh: Questionnaires.LabAmh,
  prolactin: Questionnaires.LabProlactin,
  dhea: Questionnaires.LabDhea,
  "free-testosterone": Questionnaires.LabFreeTestosterone,
  "vulvar-biopsy": Questionnaires.LabVulvarBiopsy,
  "endometrial-biopsy": Questionnaires.LabEndometrialBiopsy,
  "lipid-panel": Questionnaires.LabLipidPanel,
  cmp: Questionnaires.LabCmp,
  "vitamin-b12": Questionnaires.LabVitaminB12,
  "bile-acids": Questionnaires.LabBileAcids,
  "total-iron-binding-capacity": Questionnaires.LabTotalIronBindingCapacity,
  iron: Questionnaires.LabIron,
  ferritin: Questionnaires.LabFerritin,
  fibrinogen: Questionnaires.LabFibrinogen,
  ldh: Questionnaires.LabLdh,
  "uric-acid": Questionnaires.LabUricAcid,
  ast: Questionnaires.LabAst,
  alt: Questionnaires.LabAlt,
  urinalysis: Questionnaires.LabUrinalysis,
  rh: Questionnaires.LabRh,
  ana: Questionnaires.LabAna,
  esr: Questionnaires.LabEsr,
  crp: Questionnaires.LabCrp,
  cortisol: Questionnaires.LabCortisol,
  "urine-culture": Questionnaires.LabUrineCulture,
  colposcopy: Questionnaires.LabColposcopy,
  "p-c-ratio": Questionnaires.LabPCRatio,
  "24-hour-urine-protein": Questionnaires.Lab24HourUrineProtein,
};
